import React from 'react'

import { Form } from '_zari/core'

const FilaDetalleTemplate = ({ index, row, actualizarFilaHandler }) => {
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [precio, setPrecio] = React.useState(row.precio)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      __focusPrecio = true
      saltarCampo = true
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpPrecioHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = false
    let __focusPrecio = true
    let __focusDescuento = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarCampo = true
      saltarFila = true
    }
    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      __focusDescuento,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>{row.nombreProducto || '--'}</td>
        <td>{`${row.unidadMedida}${row.equivalencia === 1 ? '' : `x${row.equivalencia}`}`}</td>
        <td>
          <Form.InputText
            ref={inputCantidadRef}
            placeholder='0'
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td>
          <Form.InputText
            placeholder='0'
            value={precio}
            onChange={e => setPrecio(e.target.value)}
            onKeyUp={keyUpPrecioHandler}
            onKeyDown={keyDownPrecioHandler}
            onFocus={e => e.currentTarget.select()}
            autoFocus={row.__filaActiva && row.__focusPrecio}
          />
        </td>
        <td>{row.subTotal || '--'}</td>
        <td>{row.titulo || '--'}</td>
        <td>{row.fechaEmision || '--'}</td>
        <td>{row.moneda || '--'}</td>
        <td>
          {row.tipoDocumento || '--'} - {row.serieDocumento || '--'} - {row.numeroDocumento || '--'}
        </td>
        <td>{row.usuario || '--'}</td>
      </tr>
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
